// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"dc5becec","430":"c3c6d1cf","546":"6dee6953","632":"baad13b1","693":"249c7825","775":"703d1fed","818":"3c34e1ad","859":"5dfc4dcc","939":"46bc5dd3","964":"59e9430a"}[chunkId] + ".chunk.js";
};